<template>
  <div class="nav-box">
    <a
      class="nav-item"
      :class="{ active: cur == index }"
      v-for="(item, index) in navList"
      :key="index"
      @click="navTabClick(item, index)"
    >
      <i class="iconfont icon1" v-if="item.name == '首页'">&#xe8b9;</i>
      <i class="iconfont icon2" v-if="item.name == '在线咨询'">&#xe67b;</i>
      <i class="iconfont icon3" v-if="item.name == '律师服务面对面'"
        >&#xe65e;</i
      >
      <i class="iconfont icon4" v-if="item.name == '法律援助'">&#xe658;</i>
      <i class="iconfont icon5" v-if="item.name == '职工维权问答'">&#xe8c6;</i>
      <i class="iconfont icon6" v-if="item.name == '案例库'">&#xe67c;</i>
      {{ item.name }}</a
    >
  </div>
</template>
<script>
import { caseLogin } from "../../public/commonJs";
export default {
  name: "NavTab",
  data() {
    return {
      cur: 0,
      navList: [
        {
          name: "首页",
          navPath: "/FirstHome",
        },
        {
          name: "在线咨询",
          navPath: "/OnlineConsultation/OnlineCult",
        },
        {
          name: "律师服务面对面",
          navPath: "/LawyerArea",
        },
        {
          name: "法律援助",
          navPath: "/LegalAidApply",
        },
        {
          name: "职工维权问答",
          navPath: "/EpRightsProtection",
        },
        // {
        //   name: '案例库',
        //   navPath: '/CaseBase',
        // },
      ],
    };
  },
  mounted() {
    // console.log(JSON.parse(sessionStorage.getItem('cur')))
    this.cur = sessionStorage.getItem("cur")
      ? JSON.parse(sessionStorage.getItem("cur"))
      : 0;
  },
  methods: {
    navTabClick(item, index) {
      if (this.$route.path !== item.navPath) {
        //判断是否登录
        if (
          item.navPath == "/OnlineConsultation/OnlineCult" ||
          item.navPath == "/LawyerArea" ||
          item.navPath == "/LegalAidApply"
        ) {
          if (caseLogin()) {
            this.$router.push(item.navPath);
            this.cur = index;
            sessionStorage.setItem("cur", this.cur);
          }
        } else {
          this.$router.push(item.navPath);
          this.cur = index;
          sessionStorage.setItem("cur", this.cur);
        }
      }
    },
  },
};
</script>
<style scoped>
.nav-box {
  height: 66px;
  line-height: 66px;
  background: url("~@/assets/images/bar.png") repeat-x;
  display: flex;
  justify-content: center;
}
.nav-item {
  color: #eee;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  flex: 1;
}
.nav-item.active {
  background: url("~@/assets/images/bar_cur.png") repeat-x;
}
.nav-item i {
  color: #9ecff5;
}
.nav-item.active i {
  color: #11e0ff;
}
.icon1 {
  font-size: 20px;
  vertical-align: -1px;
}
.icon2 {
  font-size: 20px;
  vertical-align: -2px;
}
.icon3 {
  font-size: 22px;
  vertical-align: -2px;
}
.icon4 {
  margin-right: 3px;
}
.icon5 {
  font-size: 22px;
  vertical-align: -2px;
}
.icon6 {
  font-size: 22px;
  vertical-align: -3px;
}
</style>
